import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo:'login',
    pathMatch: 'full'
  },
  {
    path: 'main',
    loadChildren: () => import('./main/main.module').then( m => m.MainPageModule)
  },
  {
    path: 'profilo',
    loadChildren: () => import('./profilo/profilo.module').then( m => m.ProfiloPageModule)
  },
  {
    path: 'attivita',
    loadChildren: () => import('./attivita/attivita.module').then( m => m.AttivitaPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'statistiche',
    loadChildren: () => import('./statistiche/statistiche.module').then( m => m.StatistichePageModule)
  },
  {
    path: 'clienti',
    loadChildren: () => import('./clienti/clienti.module').then( m => m.ClientiPageModule)
  },
  {
    path: 'rapportino',
    loadChildren: () => import('./rapportino/rapportino.module').then( m => m.RapportinoPageModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
